<script setup>
import Icon from '@js/Components/Icon/Icon.vue'

defineProps({
  big: {
    type: Boolean,
    default: false
  },
  withDeadBirdIcon: {
    type: Boolean,
    default: false
  },

  dusk: {
    type: [String, null],
    default: null
  }
})
</script>
<template>
  <div
    :dusk="dusk"
    :class="{
      ['text-danger text-base block']: !big,
      [`text-white text-base bg-danger px-6 py-2 rounded text-center inline-block`]: big
    }"
  >
    <slot />
    <Icon v-if="withDeadBirdIcon" name="dead-bird" icon-width="w-[28px] inline relative top-[3px] left-[4px]" />
  </div>
</template>
